import { FeatureGates } from 'lib/statsig/feature_gates'
import { useGateValue } from '@statsig/react-bindings'

export default function FeatureGateGuard({
  children,
  featureGate,
  fallback = null,
}: {
  children: React.ReactNode
  featureGate: FeatureGates
  fallback?: React.ReactNode
}) {
  const isEnabled = useGateValue(featureGate)
  if (!isEnabled) {
    return fallback
  }
  return children
}
